import { ThemeProvider } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { SocialAuthProvider } from '@/contexts/socialAuth';

import { Header } from '@/components/header/landing/Header';
import { Notifier } from '@/components/notifier/Notifier';

import { LandingRoutes } from '@/routes/LandingRoutes';
import { colors } from '@/themesConfig/colors';
import { lightTheme } from '@/themesConfig/themes/light';

const useStyles = makeStyles(
  () => ({
    layout: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: colors.paynesGray,
      height: 'var(--screenHeight, 100vh)',
      overflow: 'auto',
    },
  }),
  {
    name: 'LandingPage',
  },
);

const LandingPage = () => {
  const classes = useStyles();

  return (
    <ThemeProvider theme={lightTheme}>
      <div className={classes.layout}>
        <Header />

        <SocialAuthProvider>
          <LandingRoutes />
        </SocialAuthProvider>

        <Notifier />
      </div>
    </ThemeProvider>
  );
};

export default LandingPage;
